import moment from 'moment';

/**
 * filterNulls removes all source nulls (-9999) 
 * and replaces them with a plotly null value ("") 
 * @param {number[]} timeseries 
 * @returns {any[]} a timeseries with no nulls, ready for use in plotly
 */
export function filterNulls(timeseries) {
    let data = [];
    for (let j = 0; j < timeseries.length; j++) {
        if (timeseries[j] === -9999) {
            data.push("");
        } else {
            data.push(timeseries[j]);
        }
    }

    return data;
}

function getNextMonth(date) {
    if (date.getMonth() === 11) {
        return new Date(date.getFullYear() + 1, 0, 1);
    } else {
        return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    }
}

/**
 * creates a list of dates that matches up with the series object.
 * The series object must have, a startDate and a timeStepInSeconds
 * property
 * @param {object} series series to create dates from 
 * @returns {array<object>}a list of date values to be used in plotly
 */
export function createDateArray(series) {
    let dates = [];
    let time = new Date(series.startDate);
    for (let step = 0; step < series.values.length; step++) {
        dates.push(moment(time).format('MMM YYYY'));
        // need to increment in milliseconds
        if (series.timeStep === 'Daily') {
            time.setTime(time.getTime() + 86400 * 1000);
        } else if (series.timeStep === 'Monthly') {
            time = getNextMonth(time);
        }
    }
    return dates;
}


export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

export function groupByMonth(series) {
    let res = [];

    let currentBucket = [];
    let total = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let month = 0;
    for (let i = 1; i <= series.values.length; i++) {
        let value = series.values[i - 1];
        // filter out null values
        if (value === -9999) {
            value = '';
        }
        else {
            total[month] += series.values[i - 1];
            count[month] += 1;
        }
        currentBucket.push(value);
        if (i % 12 === 0) {
            res.push(currentBucket);
            currentBucket = [];
            month = 0;
        } else {
            month++;
        }
    }

    let averages = [];
    for (let i = 0; i < 12; i++) {
        averages.push(total[i] / count[i]);
    }

    return { monthlyValues: res, averages: averages };
}



// WEBPACK FOOTER //
// ./src/util/timeseries.js